<script lang="ts">
    import type {DirectoryInsight} from 'typings/portaro.be.types';
    import type {DocumentDetailReactivePageData, DocumentDetailStaticPageData} from '../types';
    import {getLocalization} from 'core/svelte-context/context';
    import {pipe} from 'core/utils';
    import {encodeUri} from 'shared/utils/pipes';
    import {FileViewForm} from 'shared/constants/portaro.constants';
    import {exists} from 'shared/utils/custom-utils';
    import {getPageContext} from 'shared/layouts/page-context';
    import {onDestroy} from 'svelte';
    import KpGenericPanel from 'shared/ui-widgets/panel/KpGenericPanel.svelte';

    const localize = getLocalization();
    const pageContext = getPageContext<DocumentDetailStaticPageData, DocumentDetailReactivePageData>();

    const model = pageContext.staticData.model;
    let directoryInsight: DirectoryInsight | undefined;
    const reactiveDataUnsubscribe = pageContext.reactiveData.subscribe((data) => directoryInsight = data.directoryInsight);
    onDestroy(reactiveDataUnsubscribe);
</script>

{#if exists(directoryInsight) && (directoryInsight.sampleFiles.length > 0 || directoryInsight.containsNonCoverFiles || directoryInsight.containsSubdirectories)}
    <div class="side-column-panel">
        <section class="attachments-panel" aria-labelledby="attachments-panel-label">
            <KpGenericPanel hasBodyPadding={false}>
                <svelte:fragment slot="heading">
                    <h2 id="attachments-panel-label" class="unset-style">
                        {localize(/* @kp-localization detail.PrilohyKeStazeni */ 'detail.PrilohyKeStazeni')}
                    </h2>
                </svelte:fragment>

                <ul class="attachments-list">
                    {#if directoryInsight.containsNonCoverFiles || directoryInsight.containsSubdirectories}
                        <li class="attachment-item">
                            <a href="/media-viewer?rootDirectory={model.record.directoryId}&origin={pipe(window.location.href, encodeUri())}">
                                {localize(/* @kp-localization file.ZobrazitPripojeneSoubory */ 'file.ZobrazitPripojeneSoubory')}
                            </a>
                        </li>
                    {/if}

                    {#each directoryInsight.sampleFiles as file(file.id)}
                        <li class="attachment-item">
                            <a href="/media-viewer?rootDirectory={model.record.directoryId}&origin={pipe(window.location.href, encodeUri())}#!?file={file.id}">
                                <div class="attachment-item-inner">
                                    {#if file.viewForms.includes(FileViewForm.THUMBNAIL)}
                                        <img class="connected-file-thumbnail"
                                             src="/files/{file.id}?width=80"
                                             alt={file.name}
                                             width="60"/>
                                    {/if}

                                    <span class="connected-file-label">
                                        {file.name}
                                    </span>
                                </div>
                            </a>
                        </li>
                    {/each}
                </ul>
            </KpGenericPanel>
        </section>
    </div>
{/if}

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .attachments-list {
        display: flex;
        flex-direction: column;

        .attachment-item {
            padding: @spacing-sm @spacing-ml;
            border-bottom: 1px solid @themed-border-default;

            &:last-child {
                border-bottom: none;
            }

            .attachment-item-inner {
                display: flex;
                align-items: center;
                gap: @spacing-sm;
            }
        }
    }

    .connected-file-thumbnail {
        border: 1px solid @themed-border-default;
        border-radius: @border-radius-small;
    }
</style>